import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {mergeMap} from 'rxjs/operators';
import {MeasurementUnitModel} from '../_models/measurement-unit.model';
import {environment} from '@environments/environment';
import {QueryParamsModel} from '@core/models/query-models/query-params.model';

@Injectable({
  providedIn: 'root'
})
export class MasterMeasurementUnitService {
  API_URL = `${environment.api_host}/api/master/measurement-unit`;
  constructor(private http: HttpClient) {}

  findMeasurementUnit(queryParams?: QueryParamsModel): Observable<MeasurementUnitModel[]> {
      // Para añadir el search o clauquier filtro solo falta añadir el queryParams en la petición
      const url = this.API_URL;
      return this.http.get<MeasurementUnitModel[]>(url).pipe(
        mergeMap(res => {
          return of(res);
        })
    );
  }
}
